export default "__VITE_ASSET__mlVhnVuL__"